import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  NavLink,
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
} from "react-router-dom";
import classNames from "classnames";

import { useAppDispatch } from "../../../redux";

import { getBrandDataAction } from "../../../redux/dashboard/brand-slice";

import AITrainingData from "./AITrainingData";
import BrandSummary from "./BrandSummary";
import Loader from "../../../components/loader";

interface TabHeader {
  name: string;
  id: string;
  content: React.ReactNode;
}

const AITraining = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { url, path } = useRouteMatch();

  const { pathname } = history.location;

  const [activeTab, setActiveTab] = useState("");
  const [isRefetchBrandData, setIsRefetchBrandData] = useState(false);
  const { brandData, isFetchingBrandData } = useSelector(
    (state: any) => state.brandSlice
  );

  useEffect(() => {
    const segments = pathname.split("/").filter(Boolean);
    const lastSegment = segments[segments.length - 1];
    setActiveTab(lastSegment);
  }, []);

  useEffect(() => {
   dispatch(getBrandDataAction());
    if (isRefetchBrandData) setIsRefetchBrandData(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRefetchBrandData]);

   

  const tabHeader: TabHeader[] = [
    {
      id: "ai-training-data",
      name: "AI Training Data",
      content: (
        <AITrainingData
          brandData={brandData}
          setIsRefetchBrandData={setIsRefetchBrandData}
        />
      ),
    },
    {
      id: "brand-summary",
      name: "Brand Summary",
      content: <BrandSummary brandData={brandData} />,
    },
  ];

  return (
    <div className="content_container">
      <div className="ai_training">
        <div className="tab_header">
          {tabHeader.map((tabHeader) => (
            <NavLink to={`${url}/${tabHeader.id}`}>
              <div
                className={classNames("title", {
                  active: tabHeader.id === activeTab,
                })}
                key={tabHeader.id}
                onClick={() => setActiveTab(tabHeader.id)}
              >
                <p>{tabHeader.name}</p>
              </div>
            </NavLink>
          ))}
        </div>
        {isFetchingBrandData ? (
          <Loader />
        ) : brandData ? (
          <Switch>
            {tabHeader.map((tabHeader) => (
              <Route
                exact
                path={`${path}/${tabHeader.id}`}
                render={() => (
                  <div className="tab_content">{tabHeader.content}</div>
                )}
              />
            ))}
            <Redirect from={path} to={`${url}/${tabHeader?.[0]?.id}`} />
          </Switch>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default AITraining;
